import React from 'react';
import { Box, CardContent, Typography, Chip } from '@mui/material';
import { Groups as GroupsIcon } from '@mui/icons-material';
import { C } from './constants';
import { GlowCard, MemberRow } from './ui';

/**
 * StaffCard — scrollable list of non-player members (coaches, managers, etc).
 *
 * Props:
 *   staff — enriched member objects whose role !== 'player'
 */
const StaffCard = ({ staff = [], delay = 0 }) => (
  <GlowCard delay={delay} accent={C.emerald}>
    <CardContent sx={{ p: 3 }}>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <GroupsIcon sx={{ color: C.emerald, fontSize: 20 }} />
          <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.text, fontSize: '1rem' }}>
            Encadrement
          </Typography>
        </Box>
        <Chip
          label={`${staff.length} membre${staff.length !== 1 ? 's' : ''}`}
          size="small"
          sx={{
            background: `${C.emerald}18`, border: `1px solid ${C.emerald}30`,
            color: C.emerald, fontFamily: 'DM Sans', fontSize: '0.72rem',
          }}
        />
      </Box>

      <Box sx={{
        maxHeight: 320, overflowY: 'auto', pr: 0.5,
        '&::-webkit-scrollbar': { width: 4 },
        '&::-webkit-scrollbar-track': { background: 'transparent' },
        '&::-webkit-scrollbar-thumb': { background: C.border, borderRadius: 99 },
      }}>
        {staff.length === 0
          ? <Typography sx={{ fontFamily: 'DM Sans', color: C.muted, fontSize: '0.85rem' }}>Aucun membre trouvé.</Typography>
          : staff.map((m, i) => <MemberRow key={m._id} member={m} index={i} />)
        }
      </Box>

    </CardContent>
  </GlowCard>
);

export default StaffCard;
